<template>
  <div class="centerArea_wrapper">
    <Skyway type="mesh" />
    <div class="videoTitle_wrapper wrapper hard">
      <div class="videoTitle_inner flex_center">
        <div class="flex_center">
          <div class="extBtn_wrapper">
            <router-link :to="{name: 'Top', params: {slug: $route.params.slug}}" class="ext_btn flex_center btn">
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </router-link>
          </div>
          <h2 class="videoTitle inner light">
            <span>トークルーム</span>
          </h2>
        </div>
      </div>
      <div class="videoTxt_wrapper wrapper background">
        <p>
          <span>1対1のプライベートなトークルームです。他の人は入ることができません。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Skyway from "../modules/Skyway"

export default {
  name: "TalkRoom",
  components: {Skyway},
  mounted() {
    this.$store.commit("loading/setLoading", false)
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 992) {
        this.$store.commit("sideMenu/collapseByLeft", false)
        this.$store.commit("sideMenu/collapseByRight", false)
      } else {
        return
      }
    }
  }
}
</script>
